// extracted by mini-css-extract-plugin
export default {"container":"_addToPlaylistPopUp_container__fzK2-","addToPlaylist":"_addToPlaylistPopUp_addToPlaylist__x7GUm","createPlaylist":"_addToPlaylistPopUp_createPlaylist__8LQUn"};